const translations = {
  name: 'Name',
  slaType: 'SLA Type',
  duration: 'Duration',
  slaUnit: 'SLA Unit',
  checklists: 'Checklists',
  places: 'Places',
  createdAt: 'Created at',
  emptyMessage: 'No data found',
  'slaUnits.day': 'Days',
  'slaUnits.hour': 'Hours',
  'slaUnits.minute': 'Minutes',
  'slaTypes.creationDate': 'Opening date',
  'slaTypes.schedulingDate': 'Scheduling date',
  'header.title': 'SLA settings',
  'header.subtitle': 'Manage the system SLA settings: view, create or edit as needed.',
  'header.newConfig': 'New configuration',
  'modal.listTitle': 'SLA settings',
  'modal.editTitle': 'Edit SLA',
  'modal.newTitle': 'New SLA'
}

export default translations
